// GetStarted.jsx

import "../../styles/garage/garage-main.css";

export default function GetStarted() {
    return (
        <section className="garage-start" id="get-started">
            <div className="start-inner">
                <div className="start-content">
                    <div className="section-label light">
                        <span></span>
                        Get started
                    </div>

                    <h2>
                        Ready to run your
                        <br />
                        <span>garage smarter?</span>
                    </h2>

                    <p>
                        Leave your email or phone number and we'll help
                        you get your garage set up.
                    </p>

                    <form className="start-form">
                        <input
                            type="text"
                            placeholder="Email or phone number"
                            aria-label="Email or phone number"
                        />

                        <button type="submit">
                            Get Started
                            <span>→</span>
                        </button>
                    </form>

                    <div className="start-note">
                        <span>✓</span>
                        No credit card required
                    </div>
                </div>

                <div className="start-decoration">
                    <div className="decoration-circle circle-one"></div>
                    <div className="decoration-circle circle-two"></div>

                    <div className="decoration-card">
                        <span>GARAGE</span>
                        <strong>MANAGEMENT</strong>
                        <small>Made smarter.</small>
                    </div>
                </div>
            </div>
        </section>
    );
}